module.exports = __webpack_public_path__ + "static/img/cangku5.05f6dd81.png";